import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl';
import constants from '../../utils/constants';
import API from '../../utils/API';

class Support extends React.Component {
  state = {
    receiversByModel: [],
    customersRegisteredRx: 0,
    cmses: [],
  }

  componentDidMount(){
    API.getCmses()
    .then((res)=>{
      console.log(res);
      this.setState({cmses: res.data});
    }).catch((err)=>{
      console.error(err);
    })
    if(this.props.user.permissions.find(permission => permission.id === constants.permissionIds.support)){
      API.getReceiverModelCounts()
      .then((res)=>{
        this.setState({receiversByModel: res.data})
      }).catch((err)=>{
        console.error(err);
      })
      API.getCmsCounts()
      .then((res)=>{
        const count = res.data.reduce((prev, curr)=>{
          curr.count = parseInt(curr.count);
          if(curr.count > 0) {
            return prev + 1
          }
          return prev
        }, 0)
        this.setState({customersRegisteredRx: count})
      }).catch((err)=>{
        console.error(err);
      })
    }
  }
  //Number of receivers per model
  receiversPerProduct(){
    return this.state.receiversByModel.map((model)=>{
      if(model.model_name === null){
        model.model_name = 'Uncategorized';
      }
      return(<div key={model.model_name}>{model.model_name}: {model.count}</div>)
    })
  }
  
  render () {
    return (
      <div>
        <main>
          <h3 className='title'><FormattedMessage id="SUPPORT" /></h3>
          <div className="card" style={{ padding: '16px'}}>
            <div><FormattedMessage id="VERSION" /><FormattedMessage id="SYMBOL_COLON" /> {process.env.REACT_APP_VERSION}</div>
            <div><FormattedMessage id="ACCOUNT_ID" /><FormattedMessage id="SYMBOL_COLON" /> {this.props.user.email} ({this.props.user.id})</div>
            <div><FormattedMessage id="CMSES" /><FormattedMessage id="SYMBOL_COLON" /> 
              <div style={{marginLeft: '20px'}}>
                {this.state.cmses.map((cms)=>{
                  return <div key={cms.id}>{cms.name} ({cms.id})</div>
                })}
              </div>
            </div>
            <div><FormattedMessage id="COMPANY_ID" /><FormattedMessage id="SYMBOL_COLON" /> {this.props.user.account.companyName} ({this.props.user.account.id})</div>
            <div><FormattedMessage id="WITH_ROLES" /><FormattedMessage id="SYMBOL_COLON" /> 
              {' ' + this.props.user.roles.map((role) => {
                return role.name
              }).join(', ')}
            </div>
            <div><FormattedMessage id="WITH_BASE_PERMISSIONS" /><FormattedMessage id="SYMBOL_COLON" /> 
              {' ' + this.props.user.permissions.map((permission)=>{
                return this.props.intl.formatMessage({id: permission.id})
              }).join(', ')}
            </div>
            {this.props.user.permissions.find(permission => permission.id === constants.permissionIds.support)
              && 
              <div>
                <div>
                  <FormattedMessage id="RECEIVERS_PER_PRODUCT" /><FormattedMessage id="SYMBOL_COLON" />
                  <div style={{marginLeft: '20px'}}>
                    {this.receiversPerProduct()}
                  </div>
                </div>
                <div><FormattedMessage id="TOTAL_RECEIVERS" /><FormattedMessage id="SYMBOL_COLON" />{this.state.receiversByModel.reduce((prev, model)=>{return prev + parseInt(model.count)}, 0)}</div>
                <div>
                  <FormattedMessage id="CUSTOMERS_REGISTERED_RXS" /><FormattedMessage id="SYMBOL_COLON" />{this.state.customersRegisteredRx}
                </div>
              </div>
            }
          </div>
        </main>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(injectIntl(Support))
